import React from "react";
import { PrimaryButton, Stack } from "@fluentui/react";

interface Props {
    usedExistingAccount?: boolean;
    customerRef?: string;
}

export const StepComplete: React.FC<Props> = ({ usedExistingAccount, customerRef }) => {

    const handleLogin = () => {
        window.location.href = "https://www.zedx.net";
    };

    return (
        <div className="step-welcome-container">

            {/* HEADING */}
            <h2 className="create-account-heading">
                {usedExistingAccount ? "Account Found" : "Account Created"}
            </h2>

            <div className="step-welcome-layout">

                {/* TEXT */}
                <div className="step-welcome-text">

                    {usedExistingAccount ? (
                        <>
                            <p>
                                An account already exists for this email address.
                            </p>

                            <p>
                                You can log in using your existing credentials and continue using the platform.
                            </p>
                        </>
                    ) : (
                        <>
                            <p>
                                Your account has been successfully created and your environment is ready to use.
                            </p>

                            {customerRef && (
                                <p>
                                    <strong>Customer ID:</strong> {customerRef}
                                </p>
                            )}

                            <p>
                                You can now log in and start using ZedX.
                            </p>
                        </>
                    )}

                </div>



            </div>

            {/* BUTTON */}
            <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: 12 }} className="step-actions-btns">
                <PrimaryButton text="Go to Login" onClick={handleLogin} />
            </Stack>

        </div>
    );
};